import * as React from 'react';

import { ActionButtonVariants } from 'components/action-button';
import { LogUserErrorSeverity, useLogUserErrorMessage } from 'hooks/log-user-error-message';
import { t } from 'state/intl/translations';
import { routes } from 'utils/routing';

import { ModalContent } from '../styled';

import {
  ButtonContainer,
  Container,
  LoadingText,
  StyledActionButton,
  StyledActionLink,
} from './styled';
import { IDeliveryUnavailableProps } from './types';

/**
 *
 * DeliveryUnavailable informs the guest that the address they entered
 * is unable to receive delivery at this time
 *
 */

export const DeliveryUnavailable: React.FC<React.PropsWithChildren<IDeliveryUnavailableProps>> = ({
  address,
  close,
}) => {
  useLogUserErrorMessage({
    message: 'delivery-unavailable-for-address',
    severity: LogUserErrorSeverity.Irrecoverable,
  });

  return (
    <Container testID="delivery-unavailable-for-address">
      <ModalContent>
        <LoadingText>{t('cannotDeliveryTo')}</LoadingText>
        <LoadingText>{address}</LoadingText>
        <ButtonContainer>
          <StyledActionLink fullWidth to={routes.storeLocator}>
            {t('orderPickup')}
          </StyledActionLink>
        </ButtonContainer>
        <ButtonContainer>
          <StyledActionButton
            testID="use-different-address"
            fullWidth
            onPress={close}
            variant={ActionButtonVariants.OUTLINE}
          >
            {t('useDifferentAddress')}
          </StyledActionButton>
        </ButtonContainer>
      </ModalContent>
    </Container>
  );
};
